import React from "react";
import { FeaturePageShell } from "./FeaturePageShell";
import geoImage from "./assets/geolocalisation/geo.png";

const steps = [
  ["Hyper-local proximity alerts", "The moment an editorial slot opens for a territory, qualified Weavers inside the geographic radius can be alerted to capture the scene as it unfolds."],
  ["Context & skill matching", "The match looks beyond basic GPS distance by combining exact coordinates with camera gear, visual style and verified interests."],
  ["Ready-to-shoot slot briefs", "Each notification can carry the requested framing, duration and narrative focus so the Weaver knows exactly what to capture."],
  ["Shoot, upload & Smart Escrow", "The capture is uploaded directly to the designated slot, with the bounty released when the cut is approved and hot-swapped into the live stream."],
];

export default function GeolocalisationPage() {
  return (
    <FeaturePageShell
      pageTitle="Geolocalisation"
      currentPath="/use-cases/geolocalisation"
      eyebrow="GEOLOCATED RADAR · LOCAL THREADS"
      heroTitle="Right place, right time."
      heroText="Location-aware intelligence turns physical proximity into spontaneous storytelling: nearby creators can be matched to active stories, points of interest and live productions as capture needs appear."
      heroImage={geoImage}
      heroAlt="Weavevo geolocated Local Threads notification in a street scene"
      finalEyebrow="LOCAL THREADS"
      finalTitle="The world is your decentralized film studio."
      finalText="Receive capture opportunities wherever you go and turn on-the-ground presence into monetized Living Media."
    >
      <section className="fp-section">
        <div className="fp-sectionHead">
          <span className="fp-sectionEyebrow">ACTIVE AROUND YOUR AREA</span>
          <h2>A local story can become a capture mission in seconds.</h2>
          <p>The workflow moves from proximity detection to a structured shot brief, contribution and approval without the back-and-forth of traditional field coordination.</p>
        </div>
        <div className="fp-radarLayout">
          <figure className="fp-radarVisual"><img src={geoImage} alt="Local Threads geolocation experience" loading="lazy" /></figure>
          <div className="fp-radarSteps">
            {steps.map(([title, text], index) => (
              <article className="fp-radarStep" key={title}>
                <span className="fp-radarNumber">{String(index + 1).padStart(2, "0")}</span>
                <div><h3>{title}</h3><p>{text}</p></div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="fp-section">
        <div className="fp-quoteBand">
          <span className="fp-eyebrow">WHY THIS MATCH</span>
          <strong>Distance is only the first signal.</strong>
          <p>Matching can combine coordinates with equipment, visual style and verified interests such as hospitality, architecture, culture or field reporting to keep opportunities relevant.</p>
        </div>
      </section>
    </FeaturePageShell>
  );
}
